<template>
<div>
    <el-dialog 
        title="编辑图片" 
        :visible.sync="show" 
        @close="dialogFormVisible" 
        :width="autoCropWidth>600?autoCropWidth+240+'px':'850px'" 
        @open="setImg"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        class="overflow-modal"
         :modal="false"
        >
        <div class="cropper-content" :style="{height:autoCropHeight+'px'}">
            <div class="cropper">
                <vueCropper
                    v-if="show"
                    ref="cropper"
                    :img="img"
                    :outputSize="size"
                    :outputType="outputType"
                    :info="true"
                    :full="full"
                    :canMove="canMove"
                    :canMoveBox="canMoveBox"
                    :original="original"
                    :autoCrop="autoCrop"
                    :autoCropWidth="autoCropWidth"
                    :autoCropHeight="autoCropHeight"
                    :fixedBox="fixedBox"
                    @realTime="startCrop"
                    @imgLoad="imgLoad"
                ></vueCropper>
            </div>
            <div class="show-preview" style="width:200px;min-height:200px;">
                <div style="width:200px;min-height:200px;" class="preview">
                    <img :src="shwoImg" style="max-width:100%">
                </div>
            </div>
        </div>

        <div class="footer-btn">
            <div class="scope-btn">
                <label class="btn" for="uploads">上传图片</label>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 1)" v-if='show'>

                <el-button  @click="changeScale(1)">+</el-button>
                <el-button  @click="changeScale(-1)">-</el-button>
                <el-button  @click="rotateLeft">↺</el-button>
                <el-button  @click="rotateRight">↻</el-button>
            </div>
            <div class="upload-btn">
                <el-button  @click="upload">完成截图</el-button>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script type="text/babel">
function noop() {}
import ajax from './ajax';
import VueCropper from 'vue-cropper'
export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
            action: {
                type: String,
                // required: true
            },
            name: {
                type: String,
                default: 'file'
            },
            cropperImg: {
                type: String,
                default:''
            },
            size: {
                type: Number,
                default: 1
            },
            full: {
                type: Boolean,
                default: false
            },
            //输出原图比例截图 props名full
            outputType: {
                type: String,
                default: 'png'
            },
            canMove: {
                type: Boolean,
                default: true
            },

            original: {
                type: Boolean,
                default: false
            },
            canMoveBox: {
                type: Boolean,
                default: true
            },
            autoCrop: {
                type: Boolean,
                default: true
            },
            autoCropWidth: {
                type: Number,
                default: 200,
            },
            autoCropHeight:  {
                type: Number,
                default: 200,
            },
            fixedBox: {
                type: Boolean,
                default: true
            },
            onProgress: {
                type: Function,
                default: noop
            },
            onSuccess: {
                type: Function,
                default: noop
            },
            onError: {
                type: Function,
                default: noop
            },
            keyString: {
                type:String,
                default:''
            },
            headers: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
                reqs: '',
                crap: false,
                previews: {},
                option: {
                    
                },
                img: this.cropperImg,
                shwoImg:''
            };
        },
        watch:{
            cropperImg() {
                this.img = this.cropperImg
            }
        },
        computed: {
                show: {
                    // getter
                    get() {
                        return this.value;
                    },
                    // setter
                    set(newValue) {
                        this.$emit('input', newValue);
                    }
                }
        },
        methods: {
            setImg() {
                this.img = this.cropperImg
            },
            startCrop(){
                this.$refs.cropper.getCropBlob(data=>{
                    this.shwoImg = window.URL.createObjectURL(data);
                })
            },
            changeScale(num) {
                num = num || 1 
                this.$refs.cropper.changeScale(num)
            },
            rotateLeft() {
                this.$refs.cropper.rotateLeft()
            },
            rotateRight() {
                this.$refs.cropper.rotateRight()
            },
            // 实时预览函数
            realTime(data) {
                this.previews = data
            },

            uploadImg(e, num) { //上传图片 
                
                this.img
                var file = e.target.files[0]
                // e.target.value 为空，避免下面的对alert
                if( !e.target.value){
                  return
                }
                if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                    alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种') 
                    return false
                }
                var reader = new FileReader() 
                reader.onload = (e) =>{
                    let data
                    if (typeof e.target.result === 'object') {
                        // 把Array Buffer转化为blob 如果是base64不需要 
                        data = window.URL.createObjectURL(new Blob([e.target.result]))
                       
                    } else {
                        data = e.target.result
                    }
                    if (num === 1) {
                        this.img = data
                    } else if (num === 2) {
                        this.example2.img = data
                    }
                    
                } // 转化为base64 
                reader.readAsDataURL(file) 
                // 转化为blob reader.readAsArrayBuffer(file) 
            },
            upload() {
                if (!this.img) {
                    this.$message.error('请选择图片');
                }
                this.$refs.cropper.getCropBlob((data) =>{
                    const options = {
                        headers: this.headers,
                        withCredentials: false,
                        file: data,
                        // data: this.data,
                        filename: this.name,
                        action: this.action,
                        keyString: this.keyString,
                        onProgress: e => {
                            this.onProgress(e, data);
                        },
                        onSuccess: res => {
                            this.onSuccess(res, data,this.keyString);
                            if (res.status == '1') {
                                this.$message.success('上传成功')
                                this.$emit('closeDialog');
                            }
                            delete this.reqs;
                        },
                        onError: err => {
                            this.onError(err, data,this.keyString);
                            delete this.reqs;
                        }
                    };

                    const req = ajax(options);
                        this.reqs = req;
                        if (req && req.then) {
                            req.then(options.onSuccess, options.onError);
                        } 
                })
            },

            imgLoad(msg) {
            },
            
            dialogFormVisible(){
                this.img = this.cropperImg;
                this.shwoImg = '';
            },
        },
        components: {
            VueCropper
        },
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import './index.scss';
</style>